import { render, staticRenderFns } from "./actFemaleMain.vue?vue&type=template&id=29efb135&scoped=true"
import script from "./actFemaleMain.vue?vue&type=script&lang=js"
export * from "./actFemaleMain.vue?vue&type=script&lang=js"
import style0 from "./actFemaleMain.vue?vue&type=style&index=0&id=29efb135&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29efb135",
  null
  
)

export default component.exports